const m = require('minthril');
const { component } = require('../../component');

function formatUsd(value, currency = 'USD') {
  if (!value) {
    return '$0.00';
  }

  if (value < 0.01) {
    return '< $0.01';
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: 4
  }).format(value);
}

const CostEstimate = component((vnode, emit) => {
  let estimate = null;
  let loading = false;
  let loadedSiteId = null;
  let activeSiteId = null;

  async function load(site, onLoad) {
    if (!site || !onLoad || loading || loadedSiteId === site.id) {
      return;
    }

    loading = true;
    emit('redraw');

    try {
      estimate = await onLoad();
      loadedSiteId = site.id;
    } catch (error) {
      loadedSiteId = site.id;
    } finally {
      loading = false;
      emit('redraw');
    }
  }

  return {
    view: ({ attrs: { site, estimate: suppliedEstimate, onLoad } }) => {
      if (site?.id !== activeSiteId) {
        activeSiteId = site?.id || null;
        estimate = null;
        loadedSiteId = null;
      }

      if (suppliedEstimate) {
        estimate = suppliedEstimate;
      } else if (site?.id !== loadedSiteId) {
        load(site, onLoad);
      }

      if (!estimate) {
        return m('section.cost-estimate',
          m('p', loading ? 'Calculating estimated spend…' : 'Estimated spend is unavailable.')
        );
      }

      return m('section.cost-estimate', [
        m('div.cost-estimate__heading', [
          m('div', [
            m('h3', 'Estimated spend'),
            m('p', 'Based on this site’s usage during the current billing period.')
          ]),
          m('strong', formatUsd(estimate.amountUsd, estimate.currency))
        ]),
        m('p.cost-estimate__note', [
          `Current billing period: ${estimate.periodStartedAt}. This is an estimate; your final bill includes your account’s shared free allowance.`
        ])
      ]);
    }
  };
});

module.exports = { CostEstimate, formatUsd };
